function spacesRemainingFilter() {
    'ngInject';

    return function (spaces) {
        if (spaces < 1) {
            return 0;
        } else {
            return spaces;
        }
    };
}

angular
    .module('BB')
    .filter('spaces_remaining', spacesRemainingFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/spaces_remaining.filter.js